import { render, staticRenderFns } from "./TrialLogin.vue?vue&type=template&id=580bd0a6"
import script from "./TrialLogin.vue?vue&type=script&lang=js"
export * from "./TrialLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports